import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { lazyImport } from '@helpers'
import {
  withApollo,
  withErrorBoundary,
  withExchangeRates,
  withI18next,
  withSkeletonTheme,
  withStaffPickImage,
  withSuspense,
  withTheme,
} from '@hocs'
import { $settings } from '@velasca/utils/globals'
import { withWishlist } from '../hocs/withWishlist'

const { RecentProductsSlider } = lazyImport(
  () => import('@components/RecentProductsSlider/RecentProductsSlider'),
  'RecentProductsSlider',
)

const emptyCartRecentProductsEl = document.getElementById(
  'empty-cart-recent-products',
)

const RecentProductsApp = () => <RecentProductsSlider />

const RecentProductsAppWrapper = pipe(
  RecentProductsApp,
  withSuspense,
  withStaffPickImage,
  withExchangeRates,
  withWishlist,
  withSkeletonTheme,
  withI18next,
  withApollo,
  withErrorBoundary,
  withTheme,
)

export const renderRecentProductsApp = () => {
  if (emptyCartRecentProductsEl && $settings.recentProductsCartEnabled) {
    ReactDOM.createRoot(emptyCartRecentProductsEl).render(
      <RecentProductsAppWrapper />,
    )
  }
}
